// extracted by mini-css-extract-plugin
module.exports = {"bottomActionButtons":"SearchCustomerComponent_bottomActionButtons__3296J"};